import { SVGProps } from "react";
import cn from "classnames";
import styles from "./Icons.module.scss";

// https://svg2jsx.com/ - convert svg to jsx

type IconComponent = (props: SVGProps<SVGSVGElement>) => JSX.Element;

const withDefaultStyles =
  (Component: IconComponent, variant?: "16x16" | "20x20" | "40x40") =>
  ({ className, ...rest }: SVGProps<SVGSVGElement>) => (
    <Component className={cn({ [styles[`icon${variant}`]]: !!variant }, className)} {...rest} />
  );

export const SeaTrackingIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 48 48" {...props}>
      <g filter="url(#filter0_d_8_58490)">
        <g clipPath="url(#clip0_8_58490)">
          <g filter="url(#filter1_ii_8_58490)">
            <path
              fill="url(#paint0_linear_8_58490)"
              d="M0 16c0-5.6 0-8.4 1.09-10.54a10 10 0 0 1 4.37-4.37C7.6 0 10.4 0 16 0h16c5.6 0 8.4 0 10.54 1.09a10 10 0 0 1 4.37 4.37C48 7.6 48 10.4 48 16v16c0 5.6 0 8.4-1.09 10.54a10 10 0 0 1-4.37 4.37C40.4 48 37.6 48 32 48H16c-5.6 0-8.4 0-10.54-1.09a10 10 0 0 1-4.37-4.37C0 40.4 0 37.6 0 32z"
            ></path>
          </g>
          <path
            fill="url(#paint1_linear_8_58490)"
            d="M18.761 33.32a.29.29 0 0 1 .005-.411l10.278-10.06a.31.31 0 0 1 .434.003l5.169 5.205a.29.29 0 0 1 .001.41l-10.162 10.31a.31.31 0 0 1-.44-.001z"
          ></path>
          <path
            fill="url(#paint2_linear_8_58490)"
            d="M16.226 30.708a.307.307 0 0 1-.439.003c-.39-.4-1.208-1.254-1.716-1.89-.557-.698-1.187-1.866-1.403-2.28a.28.28 0 0 1 .017-.292l3.464-5.121a.31.31 0 0 1 .444-.07l4.85 3.766a.29.29 0 0 1 .032.433z"
          ></path>
          <path
            fill="url(#paint3_linear_8_58490)"
            d="M15.25 30.15c-2.524-2.454-3.726-5.61-3.726-8.765s1.202-6.31 3.726-8.764 5.768-3.623 9.012-3.623 6.49 1.169 9.013 3.623S37 18.23 37 21.385c0 3.156-1.202 6.31-3.725 8.765l-8.798 8.637a.3.3 0 0 1-.425-.005l-2.049-2.11a.3.3 0 0 1 .006-.425c2.93-2.852 5.81-5.7 8.742-8.551 1.803-1.753 2.644-3.973 2.644-6.31 0-2.221-.841-4.558-2.644-6.311-1.802-1.753-4.085-2.571-6.489-2.571-2.283 0-4.686.818-6.489 2.57-1.803 1.754-2.644 3.974-2.644 6.311 0 2.22.841 4.558 2.644 6.31l.503.439a.3.3 0 0 1 .02.433l-2.059 2.15a.3.3 0 0 1-.43.002z"
          ></path>
          <path
            fill="url(#paint4_linear_8_58490)"
            d="M18.613 26.878c-1.562-1.52-2.283-3.506-2.283-5.493s.721-3.973 2.283-5.492 3.605-2.22 5.648-2.22 4.086.7 5.648 2.22c1.562 1.519 2.283 3.505 2.283 5.492s-.481 3.973-2.043 5.493l-8.974 8.538a.3.3 0 0 1-.424-.011l-1.983-2.085a.3.3 0 0 1 .006-.42l5.487-5.438 1.562-1.52 1.563-1.518c.84-.819 1.321-1.987 1.321-3.039s-.48-2.22-1.321-3.038c-.842-.818-2.043-1.286-3.125-1.286s-2.283.468-3.124 1.286-1.322 1.986-1.322 3.038.48 2.22 1.322 3.039l.375.364a.3.3 0 0 1 .005.425l-2.034 2.079a.3.3 0 0 1-.42.008z"
          ></path>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_8_58490"
          x1="0"
          x2="56.704"
          y1="48"
          y2="14.921"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#50ADFF"></stop>
          <stop offset="1" stopColor="#006FF1"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_8_58490"
          x1="20.863"
          x2="33.05"
          y1="35.907"
          y2="27.06"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0.7"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_8_58490"
          x1="18.901"
          x2="17.777"
          y1="29.264"
          y2="24.52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0.7"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_8_58490"
          x1="24.262"
          x2="14.773"
          y1="38.998"
          y2="-1.33"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_8_58490"
          x1="16.33"
          x2="18.221"
          y1="47.816"
          y2="-29.381"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="0.847" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <filter
          id="filter0_d_8_58490"
          width="78"
          height="78"
          x="-15"
          y="-12"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="3"></feOffset>
          <feGaussianBlur stdDeviation="7.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.109804 0 0 0 0 0.639216 0 0 0 0 0.74902 0 0 0 0.35 0"></feColorMatrix>
          <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_8_58490"></feBlend>
          <feBlend in="SourceGraphic" in2="effect1_dropShadow_8_58490" result="shape"></feBlend>
        </filter>
        <filter
          id="filter1_ii_8_58490"
          width="48"
          height="55"
          x="0"
          y="-3"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="4"></feOffset>
          <feGaussianBlur stdDeviation="2.5"></feGaussianBlur>
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"></feComposite>
          <feColorMatrix values="0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="shape" result="effect1_innerShadow_8_58490"></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="-3"></feOffset>
          <feGaussianBlur stdDeviation="2"></feGaussianBlur>
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"></feComposite>
          <feColorMatrix values="0 0 0 0 0.148958 0 0 0 0 0.53694 0 0 0 0 0.6875 0 0 0 0.1 0"></feColorMatrix>
          <feBlend in2="effect1_innerShadow_8_58490" result="effect2_innerShadow_8_58490"></feBlend>
        </filter>
        <clipPath id="clip0_8_58490">
          <rect width="48" height="48" fill="#fff" rx="10"></rect>
        </clipPath>
      </defs>
    </svg>
  ),
  "40x40"
);

export const AirTrackingIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 100 100" {...props}>
      <g clipPath="url(#clip0_1_710)">
        <g filter="url(#filter0_ii_1_710)">
          <path
            fill="url(#paint0_linear_1_710)"
            d="M0 32c0-11.201 0-16.802 2.18-21.08a20 20 0 0 1 8.74-8.74C15.198 0 20.8 0 32 0h36c11.201 0 16.802 0 21.08 2.18a20 20 0 0 1 8.74 8.74C100 15.198 100 20.8 100 32v36c0 11.201 0 16.802-2.18 21.08a20 20 0 0 1-8.74 8.74C84.802 100 79.2 100 68 100H32c-11.201 0-16.802 0-21.08-2.18a20 20 0 0 1-8.74-8.74C0 84.802 0 79.2 0 68z"
          ></path>
        </g>
        <path
          fill="url(#paint1_linear_1_710)"
          d="M38.284 69.237a.967.967 0 0 1 .018-1.37l21.205-20.745a1.034 1.034 0 0 1 1.448.011l10.303 10.373c.38.381.38.985.004 1.367L50.295 80.129a1.034 1.034 0 0 1-1.47-.008z"
        ></path>
        <path
          fill="url(#paint2_linear_1_710)"
          d="M33.05 63.217a1.017 1.017 0 0 1-1.46.023c-.82-.835-2.134-2.212-2.984-3.282-.986-1.242-2.062-3.295-2.534-4.235a.94.94 0 0 1 .07-.957l7.123-10.422a1.03 1.03 0 0 1 1.458-.24l8.728 6.437a.968.968 0 0 1 .134 1.45z"
        ></path>
        <path
          fill="url(#paint3_linear_1_710)"
          d="M30.75 62.42C25.5 57.265 23 50.64 23 44.012c0-6.626 2.5-13.252 7.75-18.405S42.75 18 49.5 18s13.5 2.454 18.75 7.608C73.5 30.76 76 37.388 76 44.013c0 6.627-2.5 13.253-7.75 18.406L50.221 80.286a1 1 0 0 1-1.425-.018l-3.744-3.892a1 1 0 0 1 .02-1.407c6.006-5.904 11.914-11.8 17.928-17.703 3.75-3.682 5.5-8.344 5.5-13.253 0-4.662-1.75-9.57-5.5-13.252-3.75-3.68-8.5-5.399-13.5-5.399-4.75 0-9.75 1.718-13.5 5.4-3.75 3.68-5.5 8.343-5.5 13.251 0 4.663 1.75 9.571 5.5 13.253l.76.666a1 1 0 0 1 .065 1.44l-3.749 3.95a1 1 0 0 1-1.443.008z"
        ></path>
        <path
          fill="url(#paint4_linear_1_710)"
          d="M37.748 55.548c-3.25-3.19-4.75-7.363-4.75-11.535s1.5-8.344 4.75-11.534 7.5-4.663 11.75-4.663 8.5 1.473 11.75 4.663 4.75 7.362 4.75 11.534-1.001 8.344-4.251 11.535L43.354 73.212a1 1 0 0 1-1.42-.035l-3.62-3.842a1 1 0 0 1 .021-1.393l11.163-11.167 3.25-3.19 3.25-3.191c1.75-1.718 2.75-4.172 2.75-6.38 0-2.21-1-4.663-2.75-6.381s-4.25-2.7-6.5-2.7-4.75.982-6.5 2.7-2.75 4.172-2.75 6.38 1 4.663 2.75 6.381l.52.51a1 1 0 0 1 .017 1.41l-3.717 3.834a1 1 0 0 1-1.406.03z"
        ></path>
      </g>
      <defs>
        <linearGradient id="paint0_linear_1_710" x1="-12.5" x2="89.583" y1="0" y2="100" gradientUnits="userSpaceOnUse">
          <stop offset="0.128" stopColor="#F20C43"></stop>
          <stop offset="0.544" stopColor="#F52C5C"></stop>
          <stop offset="1" stopColor="#FF517B"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_710"
          x1="42.429"
          x2="68.205"
          y1="74.399"
          y2="55.739"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0.7"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1_710"
          x1="38.316"
          x2="35.525"
          y1="60.191"
          y2="50.995"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0.7"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_1_710"
          x1="49.5"
          x2="29.405"
          y1="81"
          y2="-3.604"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_1_710"
          x1="32.998"
          x2="37.005"
          y1="99.519"
          y2="-62.593"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="0.847" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <clipPath id="clip0_1_710">
          <rect width="100" height="100" fill="#fff" rx="20"></rect>
        </clipPath>
        <filter
          id="filter0_ii_1_710"
          width="100"
          height="114.583"
          x="0"
          y="-6.25"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="8.333"></feOffset>
          <feGaussianBlur stdDeviation="5.208"></feGaussianBlur>
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"></feComposite>
          <feColorMatrix values="0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="shape" result="effect1_innerShadow_1_710"></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="-6.25"></feOffset>
          <feGaussianBlur stdDeviation="4.167"></feGaussianBlur>
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"></feComposite>
          <feColorMatrix values="0 0 0 0 0.148958 0 0 0 0 0.53694 0 0 0 0 0.6875 0 0 0 0.1 0"></feColorMatrix>
          <feBlend in2="effect1_innerShadow_1_710" result="effect2_innerShadow_1_710"></feBlend>
        </filter>
      </defs>
    </svg>
  ),
  "40x40"
);

export const RailTrackingIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 100 100" fill="none" {...props}>
    <g clipPath="url(#clip0_245_503)">
      <path
        d="M-0.000610352 20.0023C-0.000610352 8.95665 8.95369 0.00234985 19.9994 0.00234985H79.9994C91.0451 0.00234985 99.9994 8.95665 99.9994 20.0023V80.0023C99.9994 91.048 91.0451 100.002 79.9994 100.002H19.9994C8.95369 100.002 -0.000610352 91.048 -0.000610352 80.0023V20.0023Z"
        fill="url(#paint0_linear_245_503)"
      />
      <path
        d="M39.0867 69.4161C38.8521 69.1739 38.857 68.7948 39.0977 68.5592L60.5085 47.6007C60.7586 47.3559 61.1669 47.3591 61.4138 47.6076L72.1818 58.4507C72.4185 58.6891 72.4196 59.0664 72.1842 59.3053L51.0139 80.7862C50.7632 81.0406 50.3441 81.0384 50.0952 80.7815L39.0867 69.4161Z"
        fill="url(#paint1_linear_245_503)"
      />
      <path
        d="M33.8032 63.9753C33.5556 64.2324 33.1388 64.2368 32.8898 63.9814C32.0779 63.1488 30.3731 61.3694 29.3142 60.0432C28.1536 58.5897 26.8421 56.1573 26.3905 55.295C26.2886 55.1004 26.3035 54.868 26.427 54.6854L33.6433 44.0158C33.8484 43.7126 34.2769 43.6461 34.5683 43.8723L44.6723 51.7162C44.961 51.9403 44.9917 52.3564 44.7389 52.6189L33.8032 63.9753Z"
        fill="url(#paint2_linear_245_503)"
      />
      <path
        d="M31.7684 62.8125C26.511 57.6998 24.0075 51.1264 24.0075 44.5529C24.0075 37.9794 26.511 31.4059 31.7684 26.2932C37.0258 21.1805 43.7852 18.7459 50.5447 18.7459C57.3042 18.7459 64.0637 21.1805 69.3211 26.2932C74.5785 31.4059 77.082 37.9794 77.082 44.5529C77.082 51.1263 74.5785 57.6998 69.3211 62.8125L50.9932 80.8056C50.7459 81.0484 50.3483 81.0436 50.1069 80.795L45.8384 76.3985C45.5981 76.151 45.6038 75.7556 45.8511 75.515C51.9553 69.574 57.9542 63.6412 64.0637 57.6998C67.819 54.0479 69.5714 49.4221 69.5714 44.5529C69.5714 39.9271 67.819 35.0579 64.0637 31.4059C60.3084 27.754 55.5518 26.0498 50.5447 26.0498C45.7881 26.0498 40.781 27.754 37.0258 31.4059C33.2705 35.0579 31.518 39.6836 31.518 44.5529C31.518 49.1787 33.2705 54.0479 37.0258 57.6998L38.074 58.6115C38.3434 58.8458 38.3621 59.2578 38.1151 59.5155L33.8258 63.9919C33.5815 64.2468 33.1749 64.249 32.9279 63.9967L31.7684 62.8125Z"
        fill="url(#paint3_linear_245_503)"
      />
      <path
        d="M38.7782 55.9949C35.5237 52.8299 34.0216 48.6911 34.0216 44.5522C34.0216 40.4134 35.5237 36.2745 38.7782 33.1095C42.0328 29.9445 46.2888 28.4837 50.5447 28.4837C54.8007 28.4837 59.0567 29.9445 62.3113 33.1095C65.5658 36.2745 67.0679 40.4134 67.0679 44.5522C67.0679 48.6911 66.0651 52.8299 62.8106 55.9949L44.1156 73.7821C43.8654 74.0201 43.4697 74.0102 43.2318 73.76L39.1013 69.4157C38.8669 69.1692 38.8727 68.7805 39.1142 68.5411L50.5447 57.2122L53.7993 54.0472L57.0539 50.8822C58.8063 49.178 59.8077 46.7434 59.8077 44.5522C59.8077 42.3611 58.8063 39.9264 57.0539 38.2222C55.3014 36.518 52.7979 35.5441 50.5447 35.5441C48.2916 35.5441 45.7881 36.518 44.0356 38.2222C42.2831 39.9264 41.2817 42.3611 41.2817 44.5522C41.2817 46.7434 42.2831 49.178 44.0356 50.8822L44.8168 51.6423C45.0647 51.8835 45.0696 52.2802 44.8277 52.5274L40.5902 56.8576C40.3523 57.1008 39.9634 57.1089 39.7155 56.8759L38.7782 55.9949Z"
        fill="url(#paint4_linear_245_503)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_245_503"
        x1="-10.0006"
        y1="-14.4976"
        x2="89.4994"
        y2="108.502"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#CB2C2C" />
        <stop offset="1" stopColor="#FF9432" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_245_503"
        x1="43.4648"
        y1="74.8052"
        x2="68.8554"
        y2="56.3741"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.7" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_245_503"
        x1="39.3769"
        y1="60.966"
        x2="37.0361"
        y2="51.0832"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" stopOpacity="0.7" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_245_503"
        x1="50.5447"
        y1="81.2459"
        x2="30.7753"
        y2="-2.77032"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_245_503"
        x1="34.0215"
        y1="99.6169"
        x2="37.9602"
        y2="-61.2101"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="0.84748" stopColor="white" stopOpacity="0" />
      </linearGradient>
      <clipPath id="clip0_245_503">
        <rect width="100" height="100" rx="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
));

export const RoadTrackingIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 100 100" {...props}>
      <g clipPath="url(#clip0_1_656)">
        <g filter="url(#filter0_ii_1_656)">
          <path
            fill="url(#paint0_linear_1_656)"
            d="M0 32c0-11.201 0-16.802 2.18-21.08a20 20 0 0 1 8.74-8.74C15.198 0 20.8 0 32 0h36c11.201 0 16.802 0 21.08 2.18a20 20 0 0 1 8.74 8.74C100 15.198 100 20.8 100 32v36c0 11.201 0 16.802-2.18 21.08a20 20 0 0 1-8.74 8.74C84.802 100 79.2 100 68 100H32c-11.201 0-16.802 0-21.08-2.18a20 20 0 0 1-8.74-8.74C0 84.802 0 79.2 0 68z"
          ></path>
        </g>
        <path
          fill="url(#paint1_linear_1_656)"
          d="M39.086 69.417a.604.604 0 0 1 .01-.857l21.412-20.958a.646.646 0 0 1 .905.007L72.18 58.452a.604.604 0 0 1 .002.854l-21.17 21.481a.646.646 0 0 1-.919-.005z"
        ></path>
        <path
          fill="url(#paint2_linear_1_656)"
          d="M33.803 63.975a.64.64 0 0 1-.913.006c-.812-.832-2.517-2.612-3.576-3.938-1.16-1.453-2.472-3.886-2.923-4.748a.59.59 0 0 1 .036-.61l7.216-10.67a.645.645 0 0 1 .925-.143l10.104 7.844c.29.224.32.64.067.903z"
        ></path>
        <path
          fill="url(#paint3_linear_1_656)"
          d="M31.77 62.813c-5.258-5.113-7.761-11.687-7.761-18.26s2.503-13.147 7.76-18.26c5.258-5.112 12.018-7.547 18.777-7.547s13.52 2.435 18.776 7.547c5.258 5.113 7.761 11.686 7.761 18.26 0 6.573-2.503 13.147-7.76 18.26L50.994 80.806a.625.625 0 0 1-.887-.011l-4.268-4.396a.625.625 0 0 1 .012-.884c6.105-5.941 12.104-11.874 18.213-17.815 3.755-3.652 5.508-8.278 5.508-13.147 0-4.626-1.753-9.495-5.508-13.147s-8.512-5.356-13.519-5.356c-4.757 0-9.764 1.704-13.519 5.356s-5.508 8.278-5.508 13.147c0 4.626 1.753 9.495 5.508 13.147l1.048.912c.27.234.288.646.041.904l-4.289 4.476a.625.625 0 0 1-.898.005z"
        ></path>
        <path
          fill="url(#paint4_linear_1_656)"
          d="M38.778 55.995c-3.255-3.165-4.757-7.304-4.757-11.442 0-4.14 1.502-8.278 4.757-11.443s7.51-4.626 11.766-4.626 8.512 1.46 11.767 4.626c3.254 3.165 4.756 7.304 4.756 11.443s-1.002 8.277-4.257 11.442L44.115 73.782a.625.625 0 0 1-.884-.022l-4.13-4.344a.625.625 0 0 1 .013-.875l11.43-11.328 3.255-3.166 3.254-3.164c1.753-1.705 2.754-4.14 2.754-6.33 0-2.192-1.001-4.626-2.754-6.33-1.752-1.705-4.256-2.679-6.509-2.679s-4.757.974-6.509 2.678c-1.752 1.705-2.754 4.14-2.754 6.33 0 2.192 1.002 4.626 2.754 6.33l.781.76a.625.625 0 0 1 .011.886l-4.237 4.33a.625.625 0 0 1-.875.018z"
        ></path>
      </g>
      <defs>
        <linearGradient id="paint0_linear_1_656" x1="-12.5" x2="89.583" y1="0" y2="100" gradientUnits="userSpaceOnUse">
          <stop stopColor="#14C53B"></stop>
          <stop offset="0.391" stopColor="#11C88D"></stop>
          <stop offset="1" stopColor="#0CBBBB"></stop>
        </linearGradient>
        <linearGradient
          id="paint1_linear_1_656"
          x1="43.464"
          x2="68.854"
          y1="74.806"
          y2="56.375"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0.7"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint2_linear_1_656"
          x1="39.377"
          x2="37.036"
          y1="60.966"
          y2="51.083"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff" stopOpacity="0.7"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint3_linear_1_656"
          x1="50.546"
          x2="30.777"
          y1="81.246"
          y2="-2.77"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="paint4_linear_1_656"
          x1="34.021"
          x2="37.96"
          y1="99.617"
          y2="-61.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#fff"></stop>
          <stop offset="0.847" stopColor="#fff" stopOpacity="0"></stop>
        </linearGradient>
        <clipPath id="clip0_1_656">
          <rect width="100" height="100" fill="#fff" rx="20"></rect>
        </clipPath>
        <filter
          id="filter0_ii_1_656"
          width="100"
          height="114.583"
          x="0"
          y="-6.25"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="8.333"></feOffset>
          <feGaussianBlur stdDeviation="5.208"></feGaussianBlur>
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"></feComposite>
          <feColorMatrix values="0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0 0.9875 0 0 0 0.05 0"></feColorMatrix>
          <feBlend in2="shape" result="effect1_innerShadow_1_656"></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="-6.25"></feOffset>
          <feGaussianBlur stdDeviation="4.167"></feGaussianBlur>
          <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"></feComposite>
          <feColorMatrix values="0 0 0 0 0.148958 0 0 0 0 0.53694 0 0 0 0 0.6875 0 0 0 0.1 0"></feColorMatrix>
          <feBlend in2="effect1_innerShadow_1_656" result="effect2_innerShadow_1_656"></feBlend>
        </filter>
      </defs>
    </svg>
  ),
  "40x40"
);

export const ShipmentTypeAirIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
      <path
        fill="currentColor"
        d="M9.054 5c.105 0 .232.074.285.165l2.153 3.768h2.341c.723 0 1.967.588 1.967 1.311 0 .724-1.243 1.312-1.967 1.312h-2.341l-2.153 3.767a.33.33 0 0 1-.285.166H7.712a.328.328 0 0 1-.315-.418l1.005-3.515H6.276l-.885 1.18c-.044.082-.14.13-.244.13h-.82c-.213 0-.369-.2-.317-.407l.645-2.215L4.01 8.03a.328.328 0 0 1 .318-.408h.819c.103 0 .2.049.262.131l.867 1.18h2.108l-.987-3.515A.328.328 0 0 1 7.712 5z"
      ></path>
    </svg>
  ),
  "20x20"
);

export const ShipmentTypeRailIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="currentColor"
      d="M16.25 6.328v6.875c0 1.392-1.72 2.578-3.628 2.578l1.757 1.335c.166.127.073.384-.138.384H5.76c-.212 0-.304-.258-.138-.384l1.757-1.335c-1.903 0-3.628-1.183-3.628-2.578V6.328c0-1.424 1.786-2.578 3.571-2.578h5.358c1.813 0 3.571 1.154 3.571 2.578M14.91 9.98V6.973c0-.356-.3-.645-.669-.645H5.76c-.37 0-.67.289-.67.645V9.98c0 .356.3.645.67.645h8.482c.37 0 .67-.289.67-.645M10 11.7c-.863 0-1.562.673-1.562 1.503s.699 1.504 1.562 1.504 1.563-.673 1.563-1.504c0-.83-.7-1.504-1.563-1.504"
    ></path>
  </svg>
));

export const ShipmentTypeSeaIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
      <g id="ship" transform="translate(2.857143 2.857143) scale(0.892857)">
        <path
          fill="currentColor"
          d="M4.242 11.3c.327.32.964.585 1.421.59.516 0 1.126-.143 1.437-.532.214-.274.547-.43.9-.434.351.003.684.16.9.431.311.39.92.533 1.437.533.457-.005 1.095-.27 1.421-.59l2.236-2.158a.9.9 0 0 0 .228-.55.83.83 0 0 0-.54-.74l-1.015-.327v-3.41a.78.78 0 0 0-.778-.779h-1.534l-.022-.973a.583.583 0 0 0-.583-.584h-3.5a.585.585 0 0 0-.584.584l-.022.972-1.533.001a.78.78 0 0 0-.778.779v3.41l-1.016.326a.83.83 0 0 0-.54.741c0 .178.102.425.228.551zm.647-6.409h6.222v2.13l-2.873-.924A.8.8 0 0 0 8 6.065a.7.7 0 0 0-.238.032l-2.873.926zm9.474 7.795c-1.18-.206-1.106-.682-1.692-.682-.608 0-.758.736-2.337.736-1.181 0-1.768-.51-1.784-.524a.79.79 0 0 0-.545-.213c-.601 0-.768.737-2.338.737-1.181 0-1.767-.51-1.784-.523a.817.817 0 0 0-1.09-.008c-.706.607-1.793.29-1.793 1.205 0 .373.31.743.77.743.238 0 .965-.17 1.563-.506.474.267 1.252.572 2.336.572s1.857-.304 2.331-.571c.475.267 1.253.57 2.336.57s1.859-.304 2.332-.571c.601.337 1.331.505 1.562.505.459 0 .77-.366.77-.743a.75.75 0 0 0-.637-.727"
        ></path>
      </g>
    </svg>
  ),
  "20x20"
);

export const ShipmentTypeParcelIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12" {...props}>
    <path
      fill="currentColor"
      d="M11.99 3.396 10.48.586A.85.85 0 0 0 9.666 0H6.429v3.429h5.539zM0 4.286v6.428C0 11.424.576 12 1.286 12h9.428c.71 0 1.286-.576 1.286-1.286V4.286zm5.571-.857V0H2.334a.85.85 0 0 0-.814.586L.01 3.396l.023.033z"
    ></path>
  </svg>
));

export const AlertIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" fill="none" viewBox="12 12 16 11" {...props}>
    <path
      fill="#F52C5C"
      d="m27.017 11.778-6.4-2.656A1.9 1.9 0 0 0 20.002 9c-.177 0-.452.054-.615.122l-6.4 2.656A1.59 1.59 0 0 0 12 13.25C12 21.79 18.305 26 19.998 26 21.733 26 28 21.744 28 13.25c0-.645-.39-1.226-.983-1.472M19.2 14.047c0-.44.358-.797.8-.797s.8.357.8.797v3.719c0 .44-.358.797-.8.797a.8.8 0 0 1-.8-.797zm.8 7.703c-.59 0-1.067-.476-1.067-1.062s.478-1.063 1.067-1.063c.59 0 1.067.476 1.067 1.063 0 .586-.478 1.062-1.067 1.062"
    ></path>
  </svg>
));

export const AngleUpIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
      <g id="angle-up">
        <path
          fill="currentColor"
          d="M13.598 12.516a.72.72 0 0 1-.508-.21L10.002 9.22l-3.087 3.087a.719.719 0 1 1-1.017-1.017l3.596-3.595a.72.72 0 0 1 1.016 0l3.596 3.595a.72.72 0 0 1-.508 1.226"
        ></path>
      </g>
    </svg>
  ),
  "20x20"
);

export const CheckIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="currentColor"
        d="m13.803 5.152-7.62 7.65a.67.67 0 0 1-.952 0l-4.034-4.05a.677.677 0 0 1 0-.954.67.67 0 0 1 .95 0l3.56 3.573 7.145-7.173a.67.67 0 0 1 .951 0 .677.677 0 0 1 0 .954"
      ></path>
    </svg>
  ),
  "16x16"
);

export const SearchIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="none" viewBox="0 0 20 21" {...props}>
      <path
        fill="#000C37"
        d="M17.987 16.987 14.79 13.79a.77.77 0 0 0-.545-.225h-.523a6.64 6.64 0 0 0 1.412-4.105A6.67 6.67 0 0 0 8.46 2.789a6.67 6.67 0 0 0-6.672 6.67 6.67 6.67 0 0 0 6.672 6.672 6.64 6.64 0 0 0 4.105-1.411v.522c0 .206.08.401.225.546l3.198 3.197a.767.767 0 0 0 1.087 0l.908-.907a.773.773 0 0 0 .003-1.09m-9.526-3.422A4.103 4.103 0 0 1 4.355 9.46a4.103 4.103 0 0 1 4.106-4.106 4.103 4.103 0 0 1 4.105 4.106 4.103 4.103 0 0 1-4.105 4.105"
      ></path>
    </svg>
  ),
  "20x20"
);

export const SeparatorIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="2" height="30" fill="none" viewBox="0 0 2 30" {...props}>
    <path stroke="#EFF1F6" d="M1 1v28"></path>
  </svg>
));

export const TrashIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" fill="none" viewBox="0 0 20 21" {...props}>
      <path
        fill="#0C263F"
        d="M11.179 14.928h.642a.32.32 0 0 0 .228-.096.33.33 0 0 0 .094-.232V8.693a.33.33 0 0 0-.094-.232.32.32 0 0 0-.228-.096h-.642a.32.32 0 0 0-.228.096.33.33 0 0 0-.094.232V14.6c0 .087.034.17.094.232.06.061.142.096.228.096M15.57 5.74h-2.207l-.91-1.55a1.3 1.3 0 0 0-.47-.467 1.26 1.26 0 0 0-.634-.17h-2.7c-.222 0-.44.059-.634.17a1.3 1.3 0 0 0-.469.467l-.911 1.55H4.429a.42.42 0 0 0-.303.128.44.44 0 0 0-.126.31v.437c0 .116.045.228.126.31.08.082.189.128.303.128h.428v9.187c0 .349.136.682.377.928.24.247.568.385.909.385h7.714c.341 0 .668-.138.91-.385.24-.246.376-.58.376-.928V7.053h.428a.42.42 0 0 0 .303-.128.44.44 0 0 0 .126-.31v-.437a.44.44 0 0 0-.126-.31.42.42 0 0 0-.303-.128m-6.968-.795a.16.16 0 0 1 .138-.08h2.518a.16.16 0 0 1 .138.08l.468.795h-3.73zm5.254 11.295H6.143V7.053h7.714zM8.18 14.928h.642a.32.32 0 0 0 .228-.096.33.33 0 0 0 .094-.232V8.693a.33.33 0 0 0-.094-.232.32.32 0 0 0-.228-.096H8.18a.32.32 0 0 0-.228.096.33.33 0 0 0-.094.232V14.6c0 .087.034.17.094.232.06.061.142.096.228.096"
      ></path>
    </svg>
  ),
  "20x20"
);

export const ArrowRightShortIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
      <path
        d="M8.92889 14L12.8302 10.071L8.90126 6.16974"
        stroke="#000C37"
        strokeWidth="1.8"
        strokeLinecap="round"
      ></path>
    </svg>
  ),
  "20x20"
);

export const ArrowRightLongIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <g clipPath="url(#clip0)">
        <path
          fill="#FFF"
          d="m7.252 3.332.495-.49a.53.53 0 0 1 .379-.155.54.54 0 0 1 .378.156l4.339 4.282a.527.527 0 0 1 0 .748l-4.34 4.284a.52.52 0 0 1-.377.155.54.54 0 0 1-.379-.155l-.495-.49a.53.53 0 0 1 .009-.755l2.69-2.531H3.535A.53.53 0 0 1 3 7.85v-.704c0-.294.239-.53.536-.53H9.95L7.26 4.088a.524.524 0 0 1-.009-.756"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M13 13H3V2h10z"></path>
        </clipPath>
      </defs>
    </svg>
  ),
  "20x20"
);

export const LinkIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" fill="none" viewBox="0 0 13 14" {...props}>
    <path
      fill="#08F"
      d="M7.978 5.408c1.298 1.397 1.381 3.617.248 5.118-.159.211-.07.105-2.157 2.352-1.389 1.495-3.637 1.497-5.027 0-1.39-1.496-1.39-3.917 0-5.414.832-.896 1.316-1.42 1.61-1.735.19-.204.516-.064.52.224q.007.524.12 1.034a.34.34 0 0 1-.08.306L2.046 8.547c-.831.896-.835 2.348 0 3.248.832.896 2.181.9 3.017 0L6.973 9.74c.83-.895.832-2.352 0-3.248a2.1 2.1 0 0 0-.58-.444.335.335 0 0 1-.166-.337 1.46 1.46 0 0 1 .376-.832l.111-.12a.29.29 0 0 1 .35-.062c.33.178.64.416.914.712m3.98-4.286c-1.39-1.497-3.638-1.495-5.027 0-2.086 2.247-1.998 2.14-2.157 2.352-1.133 1.5-1.05 3.72.248 5.118.275.296.584.534.914.712a.29.29 0 0 0 .35-.062l.11-.12a1.46 1.46 0 0 0 .377-.832.335.335 0 0 0-.167-.337 2.1 2.1 0 0 1-.579-.444c-.832-.896-.83-2.353 0-3.248l1.91-2.056c.835-.9 2.183-.896 3.016 0 .835.9.831 2.352 0 3.248L9.789 6.707a.34.34 0 0 0-.082.306q.114.51.12 1.034c.005.289.332.428.52.224.295-.316.779-.839 1.61-1.735 1.39-1.497 1.39-3.918 0-5.414"
    ></path>
  </svg>
));

export const ContainerIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="#0C263F"
        d="M15.4 12.321h-.2V3.68h.2c.331 0 .6-.264.6-.59a.595.595 0 0 0-.6-.589H.6c-.331 0-.6.264-.6.59s.269.589.6.589h.2v8.642H.6c-.331 0-.6.264-.6.59s.269.589.6.589h14.8c.331 0 .6-.264.6-.59a.595.595 0 0 0-.6-.589m-1.4 0H2V3.68h12zm-9.2-.785c.331 0 .6-.264.6-.59V5.054a.595.595 0 0 0-.6-.59c-.331 0-.6.264-.6.59v5.892c0 .326.269.59.6.59m3.2 0c.331 0 .6-.264.6-.59V5.054a.595.595 0 0 0-.6-.59c-.331 0-.6.264-.6.59v5.892c0 .326.269.59.6.59m3.2 0c.331 0 .6-.264.6-.59V5.054a.595.595 0 0 0-.6-.59c-.331 0-.6.264-.6.59v5.892c0 .326.269.59.6.59"
      ></path>
    </svg>
  ),
  "16x16"
);

export const ArrowRoundedIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="9" height="9" fill="none" viewBox="0 0 9 9" {...props}>
    <path
      fill="#fff"
      d="m7.746.221.07 1.455A4.34 4.34 0 0 0 4.497.14 4.36 4.36 0 0 0 .216 3.688a.21.21 0 0 0 .207.25h.863a.21.21 0 0 0 .205-.163 3.092 3.092 0 0 1 5.572-1.001L5.28 2.688a.21.21 0 0 0-.221.211v.834a.21.21 0 0 0 .21.21h3.52A.21.21 0 0 0 9 3.734V.21A.21.21 0 0 0 8.79 0h-.834a.21.21 0 0 0-.21.221M4.497 7.594a3.09 3.09 0 0 1-2.566-1.368l1.79.086a.21.21 0 0 0 .22-.211v-.833a.21.21 0 0 0-.21-.211H.21a.21.21 0 0 0-.211.21V8.79A.21.21 0 0 0 .21 9h.833a.21.21 0 0 0 .211-.221l-.073-1.452A4.35 4.35 0 0 0 4.497 8.86a4.36 4.36 0 0 0 4.281-3.547.21.21 0 0 0-.207-.25h-.862a.21.21 0 0 0-.206.163 3.09 3.09 0 0 1-3.006 2.369"
    ></path>
  </svg>
));

export const AlertOrangeIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="55" height="55" fill="none" viewBox="0 0 88 91" {...props}>
    <g filter="url(#filter0_d_6741_27713)">
      <path fill="#fff" d="M32.844 28.25h22.5V53h-22.5z"></path>
      <path
        fill="url(#paint0_linear_6741_27713)"
        d="M62.595 24.355 45.72 17.323A5 5 0 0 0 44.1 17a5 5 0 0 0-1.624.323l-16.875 7.032A4.21 4.21 0 0 0 23 28.249C23 50.852 39.626 62 44.09 62c4.572 0 21.097-11.266 21.097-33.751a4.22 4.22 0 0 0-2.592-3.894m-20.61 6.004a2.11 2.11 0 0 1 4.218 0v9.844a2.11 2.11 0 0 1-4.219 0zm2.109 20.391a2.813 2.813 0 1 1 0-5.625 2.813 2.813 0 0 1 0 5.625"
      ></path>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_6741_27713"
        x1="15.969"
        x2="87.858"
        y1="57.5"
        y2="33.849"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFAB1D"></stop>
        <stop offset="1" stopColor="#F8501C"></stop>
      </linearGradient>
      <filter
        id="filter0_d_6741_27713"
        width="125"
        height="125"
        x="-18.5"
        y="-16.875"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dy="5.625"></feOffset>
        <feGaussianBlur stdDeviation="11.25"></feGaussianBlur>
        <feColorMatrix values="0 0 0 0 0.992157 0 0 0 0 0.545098 0 0 0 0 0.113725 0 0 0 0.53 0"></feColorMatrix>
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_6741_27713"></feBlend>
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_6741_27713" result="shape"></feBlend>
      </filter>
    </defs>
  </svg>
));

export const ArrowDownIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <circle cx="8" cy="8" r="8" fill="#08F"></circle>
      <path
        fill="#fff"
        d="M8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12M5.365 7.866a.46.46 0 0 1 .652-.003l1.521 1.51V5.519a.462.462 0 0 1 .924 0v3.854l1.52-1.51a.462.462 0 0 1 .65.656l-2.307 2.29a.46.46 0 0 1-.65 0L5.367 8.52a.46.46 0 0 1-.002-.653"
      ></path>
    </svg>
  ),
  "16x16"
);

export const AlertIcon1 = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <g clipPath="url(#clip0_424_258)">
        <rect x="5" y="5" width="10" height="11" fill="white" />
        <path
          d="M18.2227 3.26875L10.7227 0.143438C10.5322 0.0641016 10.2088 0 10.0024 0C9.79492 0 9.47266 0.0641016 9.28102 0.143438L1.78102 3.26875C1.08156 3.55742 0.625 4.24117 0.625 4.99937C0.625 15.0452 8.01422 20 9.99816 20C12.0303 20 19.375 14.9927 19.375 4.99937C19.375 4.24117 18.9184 3.55742 18.2227 3.26875ZM9.0625 5.9375C9.0625 5.41992 9.48242 5 10 5C10.5176 5 10.9375 5.41992 10.9375 5.9375V10.3125C10.9375 10.8301 10.5176 11.25 10 11.25C9.48242 11.25 9.0625 10.8301 9.0625 10.3125V5.9375ZM10 15C9.30961 15 8.75 14.4403 8.75 13.75C8.75 13.0597 9.30961 12.5 10 12.5C10.6904 12.5 11.25 13.0597 11.25 13.75C11.25 14.4403 10.6904 15 10 15Z"
          fill="#6570F4"
        />
      </g>
      <defs>
        <clipPath id="clip0_424_258">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "20x20"
);

export const AlertIcon2 = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <g clipPath="url(#clip0_453_6397)">
        <rect x="5" y="5" width="10" height="11" fill="white" />
        <path
          d="M18.2227 3.26875L10.7227 0.143438C10.5322 0.0641016 10.2088 0 10.0024 0C9.79492 0 9.47266 0.0641016 9.28102 0.143438L1.78102 3.26875C1.08156 3.55742 0.625 4.24117 0.625 4.99937C0.625 15.0452 8.01422 20 9.99816 20C12.0303 20 19.375 14.9927 19.375 4.99937C19.375 4.24117 18.9184 3.55742 18.2227 3.26875ZM9.0625 5.9375C9.0625 5.41992 9.48242 5 10 5C10.5176 5 10.9375 5.41992 10.9375 5.9375V10.3125C10.9375 10.8301 10.5176 11.25 10 11.25C9.48242 11.25 9.0625 10.8301 9.0625 10.3125V5.9375ZM10 15C9.30961 15 8.75 14.4403 8.75 13.75C8.75 13.0597 9.30961 12.5 10 12.5C10.6904 12.5 11.25 13.0597 11.25 13.75C11.25 14.4403 10.6904 15 10 15Z"
          fill="#02BCB1"
        />
      </g>
      <defs>
        <clipPath id="clip0_453_6397">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  "20x20"
);

export const RedCircleIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="none" viewBox="0 0 11 11" {...props}>
    <circle cx="5.324" cy="5.324" r="4.659" fill="#F52C5C" stroke="#fff" strokeWidth="1.331"></circle>
  </svg>
));

export const GreenCircleIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="none" viewBox="0 0 11 11" {...props}>
    <circle cx="5.324" cy="5.324" r="4.659" fill="#02BCB1" stroke="#fff" strokeWidth="1.331"></circle>
  </svg>
));

export const BlueCircleIcon = withDefaultStyles((props) => (
  <svg width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <circle cx="5.32404" cy="5.32404" r="4.65854" fill="#0139FF" stroke="white" strokeWidth="1.33101" />
  </svg>
));

export const OrangeCircleIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" fill="none" viewBox="0 0 11 11" {...props}>
    <circle
      cx="5.324"
      cy="5.324"
      r="4.659"
      fill="url(#paint0_linear_4376_11765)"
      stroke="#fff"
      strokeWidth="1.331"
    ></circle>
    <defs>
      <linearGradient
        id="paint0_linear_4376_11765"
        x1="0"
        x2="12.579"
        y1="10.648"
        y2="3.31"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFAB1D"></stop>
        <stop offset="1" stopColor="#F8501C"></stop>
      </linearGradient>
    </defs>
  </svg>
));

export const BluePlaneIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" fill="none" viewBox="0 0 14 13" {...props}>
    <path
      stroke="#000C37"
      d="m5.38 8.416-.969 3.522c-.066.24.107.478.347.478h1.478a.36.36 0 0 0 .314-.19m-1.17-3.81 3.542-.5-2.372 4.31m-1.17-3.81h.139v-.5l-.482-.133L5 7.916m.38.5-.38-.5m1.55 4.31-.314-.173-.124-.068.002-.003m.436.244-.314-.175-.122-.069m0 0a.14.14 0 0 1 .122-.066H6.15m-.036.066.036-.066m0 0H4.936m1.214 0 2.334-4.241.143-.259h2.875c.286 0 .738-.13 1.12-.366.41-.25.547-.496.547-.634s-.138-.383-.547-.634c-.382-.235-.834-.366-1.12-.366H8.627l-.143-.259L6.151.916m-1.215 11L6.55.605M4.936 11.916 6 8.049l.174-.633H2.92l-.15.207-.933 1.293m3.099 3h-.178c.054 0 .096.029.116.057s.028.064.02.097zm0 0 .064-4m1.15-7h.086a.2.2 0 0 1-.06-.008L6.156.9 6.144.889a.2.2 0 0 1-.03-.042m.038.069L6.113.847m.038.069H4.934M6.113.847 6.236.78 6.55.605m-.437.242L6.112.846l.124-.068.314-.173m0 0a.4.4 0 0 0-.314-.189H4.758c-.24 0-.413.238-.348.478l.953 3.522h.135v.5l-.482.13-.036-.13H3.176l-.955-1.35M4.934.916l-.04-.153h-.001a.12.12 0 0 1-.019.096.14.14 0 0 1-.116.057zm0 0 1.047 3.87.17.63H2.918l-.15-.211-.91-1.289m0 0h.075a.14.14 0 0 1-.116-.057l.116-.084.29-.209m-.366.35h-.648m.648 0-.043-.061.12-.084.288-.205m0 0a.36.36 0 0 0-.289-.15H1.03c-.235 0-.407.23-.35.466M5 7.916H3.176L2.2 9.266a.3.3 0 0 1-.269.15H1.03c-.235 0-.407-.23-.35-.466m0 0 .35.098.132.037.047-.169M.68 8.95l.71-2.534-.71-2.534m0 5.068.35.084.136.033a.12.12 0 0 0-.021-.095.15.15 0 0 0-.116-.056h.18m0 0h.628m-.629 0 .664-2.365.038-.135-.038-.135-.664-2.365m.629 5-.041.057-.022.03-.018.034a.25.25 0 0 1 .095-.1.2.2 0 0 1 .081-.021zm-.629-5H1.03a.15.15 0 0 0 .116-.056.12.12 0 0 0 .02-.095l-.136.033-.35.084m.53.034-.048-.169-.132.037-.35.098"
    ></path>
  </svg>
));

export const InfoIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="140" height="100" fill="none" viewBox="0 0 140 100" {...props}>
    <path
      fill="#EFF1F6"
      fillRule="evenodd"
      d="M89.563 33.93 48.91 23.037a4 4 0 0 0-4.9 2.829L36.037 55.63a4 4 0 0 0 2.828 4.9l40.603 10.878a1.504 1.504 0 0 1 1.886-1.372 1.5 1.5 0 0 1 .948 2.132l18.383 4.926a4 4 0 0 0 4.899-2.829l7.975-29.765a4 4 0 0 0-2.828-4.9l-18.434-4.939a1.5 1.5 0 0 1-2.733-.732m-1.635 5.775a1.5 1.5 0 1 1 2.898.776 1.5 1.5 0 0 1-2.898-.776m.154 5.216a1.5 1.5 0 1 0-.777 2.898 1.5 1.5 0 0 0 .777-2.898m-3.52 7.34a1.5 1.5 0 1 1 2.899.777 1.5 1.5 0 0 1-2.898-.777m.156 5.217a1.5 1.5 0 1 0-.776 2.898 1.5 1.5 0 0 0 .776-2.898m-3.52 7.34a1.5 1.5 0 1 1 2.897.776 1.5 1.5 0 0 1-2.897-.776"
      clipRule="evenodd"
    ></path>
    <g clipPath="url(#clip0_686_21853)">
      <path fill="#EFF1F6" d="m96.879 41.066 11.591 3.106-3.106 11.591-11.59-3.105z"></path>
      <path
        fill="#000C37"
        d="M103.574 51.549c-.503 1.071-1.641 1.533-3.028 1.331l-.204.76a.749.749 0 1 1-1.449-.388l.213-.791-.029-.01c-.57-.244-1.135-.624-1.634-.96l-.227-.152a.75.75 0 0 1 .832-1.248l.233.155c.444.3.946.638 1.39.827 1.024.443 2.202.57 2.541-.146.29-.615-.011-.97-1.614-1.905l-.315-.185c-.92-.545-2.833-1.676-1.897-3.655.497-1.053 1.631-1.517 3.022-1.313l.203-.759a.75.75 0 0 1 1.449.388l-.212.792.028.01c.368.16.775.389 1.28.72a.75.75 0 0 1 .217 1.039.75.75 0 0 1-1.038.216c-.428-.28-.773-.476-1.057-.599-1.018-.442-2.198-.569-2.537.148-.247.524-.12.878 1.308 1.721l.306.18c1.256.734 3.158 1.843 2.219 3.824"
      ></path>
    </g>
    <rect
      width="24.999"
      height="2.533"
      x="48.582"
      y="28.125"
      fill="#EFF1F6"
      rx="1.266"
      transform="rotate(15 48.582 28.125)"
    ></rect>
    <rect
      width="20.833"
      height="2.533"
      x="47.6"
      y="31.795"
      fill="#EFF1F6"
      rx="1.266"
      transform="rotate(15 47.6 31.795)"
    ></rect>
    <rect
      width="13.889"
      height="1.266"
      x="46.615"
      y="35.465"
      fill="#EFF1F6"
      rx="0.633"
      transform="rotate(15 46.615 35.465)"
    ></rect>
    <rect
      width="13.889"
      height="1.266"
      x="45.961"
      y="37.908"
      fill="#EFF1F6"
      rx="0.633"
      transform="rotate(15 45.96 37.908)"
    ></rect>
    <g filter="url(#filter0_f_686_21853)" opacity="0.15">
      <path
        fill="#000C37"
        fillRule="evenodd"
        d="M63.644 34.73a1.65 1.65 0 0 0 1.15-2.016l15.032-4.08c2.166-.587 3.25-.88 4.102-.382.853.499 1.144 1.596 1.724 3.789l7.004 26.475c.58 2.193.87 3.29.378 4.154s-1.575 1.158-3.741 1.745l-15.033 4.08a1.624 1.624 0 0 0-1.991-1.164 1.65 1.65 0 0 0-1.15 2.016l-34.66 9.406c-2.166.588-3.25.882-4.102.383s-1.144-1.596-1.724-3.79L23.63 48.873c-.58-2.193-.87-3.29-.378-4.154s1.575-1.158 3.74-1.746l34.662-9.406a1.623 1.623 0 0 0 1.99 1.165m1.893 7.157a1.65 1.65 0 0 0 1.15-2.017 1.624 1.624 0 0 0-1.992-1.164 1.65 1.65 0 0 0-1.149 2.017 1.624 1.624 0 0 0 1.991 1.164m3.043 5.14a1.65 1.65 0 0 1-1.15 2.016 1.624 1.624 0 0 1-1.99-1.164 1.65 1.65 0 0 1 1.149-2.017 1.624 1.624 0 0 1 1.99 1.164m.744 9.172a1.65 1.65 0 0 0 1.15-2.016 1.624 1.624 0 0 0-1.992-1.164 1.65 1.65 0 0 0-1.15 2.016 1.623 1.623 0 0 0 1.992 1.164m3.042 5.14a1.65 1.65 0 0 1-1.15 2.016 1.624 1.624 0 0 1-1.99-1.164 1.65 1.65 0 0 1 1.15-2.016 1.623 1.623 0 0 1 1.99 1.164"
        clipRule="evenodd"
      ></path>
    </g>
    <path
      fill="#F8F9FD"
      fillRule="evenodd"
      d="M69.515 26.705 31.843 36.8c-3.226.865-4.839 1.297-5.572 2.567-.734 1.271-.302 2.884.563 6.11l6.379 23.807c.864 3.226 1.296 4.839 2.567 5.572 1.27.734 2.883.302 6.109-.563l37.62-10.08a1.503 1.503 0 0 1 .948-2.133 1.5 1.5 0 0 1 1.886 1.374l15.407-4.129c3.226-.864 4.839-1.296 5.572-2.567.734-1.27.302-2.883-.563-6.109L96.38 26.84c-.864-3.225-1.296-4.838-2.567-5.572-1.27-.733-2.883-.301-6.109.563l-15.457 4.142a1.5 1.5 0 0 1-2.733.732m1.469 5.818a1.5 1.5 0 1 1 2.898-.776 1.5 1.5 0 0 1-2.898.776m2.744 4.44a1.5 1.5 0 1 0 .777 2.898 1.5 1.5 0 0 0-.777-2.898m.621 8.117a1.5 1.5 0 1 1 2.898-.777 1.5 1.5 0 0 1-2.898.777m2.742 4.44a1.5 1.5 0 1 0 .777 2.898 1.5 1.5 0 0 0-.776-2.898m.623 8.116a1.5 1.5 0 1 1 2.898-.776 1.5 1.5 0 0 1-2.898.776"
      clipRule="evenodd"
    ></path>
    <g clipPath="url(#clip1_686_21853)">
      <path
        fill="#000C37"
        d="M90.46 34.958c.1 1.18-.655 2.148-1.957 2.667l.204.76a.75.75 0 1 1-1.45.389l-.211-.792-.03.006c-.616.074-1.295.027-1.895-.015l-.272-.018a.75.75 0 0 1 .096-1.497l.28.019c.533.037 1.137.079 1.616.021 1.109-.128 2.193-.608 2.128-1.397-.056-.678-.495-.835-2.35-.843l-.366-.002c-1.068-.012-3.29-.036-3.47-2.218-.096-1.16.654-2.129 1.96-2.648l-.203-.758a.75.75 0 0 1 1.45-.389l.211.792.03-.006c.398-.045.865-.05 1.469-.016a.75.75 0 1 1-.084 1.498 7.4 7.4 0 0 0-1.215.01c-1.103.125-2.188.605-2.123 1.396.047.577.335.82 1.993.837l.355.002c1.455.008 3.656.017 3.834 2.202"
      ></path>
    </g>
    <rect
      width="24.999"
      height="2.533"
      x="31.998"
      y="43.471"
      fill="#9EA9B9"
      rx="1.266"
      transform="rotate(-15 31.998 43.47)"
    ></rect>
    <rect
      width="22.584"
      height="2.533"
      x="33.063"
      y="47.44"
      fill="#C9CFDB"
      rx="1.266"
      transform="rotate(-15 33.063 47.44)"
    ></rect>
    <rect
      width="15"
      height="2"
      x="34.072"
      y="51.309"
      fill="#C9CFDB"
      rx="1"
      transform="rotate(-15 34.072 51.309)"
    ></rect>
    <rect width="15" height="2" x="34.998" y="54.881" fill="#C9CFDB" rx="1" transform="rotate(-15 34.998 54.88)"></rect>
    <defs>
      <clipPath id="clip0_686_21853">
        <path fill="#fff" d="m96.879 41.066 11.591 3.106-3.106 11.591-11.59-3.105z"></path>
      </clipPath>
      <clipPath id="clip1_686_21853">
        <path fill="#fff" d="M79.42 29.227 91.01 26.12l3.106 11.59-11.591 3.107z"></path>
      </clipPath>
      <filter
        id="filter0_f_686_21853"
        width="92.035"
        height="73.142"
        x="12.125"
        y="17.123"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
        <feGaussianBlur result="effect1_foregroundBlur_686_21853" stdDeviation="5.438"></feGaussianBlur>
      </filter>
    </defs>
  </svg>
));

export const AnalyticsIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14" {...props}>
    <g id="chart-mixed" clipPath="url(#clip0_654_25719)">
      <path
        fill="#000C37"
        d="M11.832 3.37q.181.072.386.074a1.067 1.067 0 1 0-1.066-1.066q.002.078.016.158L9.048 4.23a1 1 0 0 0-.385-.075 1 1 0 0 0-.386.075l-2.12-1.694c.008-.053.017-.106.017-.158a1.067 1.067 0 0 0-2.134 0c0 .094.017.186.04.272L1.823 4.905a1 1 0 0 0-.272-.038 1.067 1.067 0 1 0 1.066 1.066c0-.094-.016-.186-.039-.272l2.256-2.256c.086.023.178.04.272.04.136 0 .267-.028.386-.076l2.12 1.695q-.015.079-.017.158a1.067 1.067 0 0 0 2.133 0c0-.053-.008-.105-.016-.158zM9.018 8.421h-.71a.71.71 0 0 0-.712.711v2.845c0 .392.318.71.711.71h.711a.71.71 0 0 0 .711-.71V9.133a.71.71 0 0 0-.71-.71m3.556-2.844h-.711a.71.71 0 0 0-.711.71v5.69c0 .392.318.71.71.71h.712a.71.71 0 0 0 .71-.71v-5.69a.71.71 0 0 0-.71-.71m-7.111 0h-.711a.71.71 0 0 0-.712.71v5.69c0 .392.319.71.712.71h.71a.71.71 0 0 0 .712-.71v-5.69a.71.71 0 0 0-.711-.71M1.907 9.133h-.711a.71.71 0 0 0-.711.711v2.134c0 .392.318.71.711.71h.711a.71.71 0 0 0 .711-.71V9.844a.71.71 0 0 0-.71-.71"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_654_25719">
        <path fill="#fff" d="M.6.6h12.8v12.8H.6z"></path>
      </clipPath>
    </defs>
  </svg>
));

export const CalendarIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="11" height="13" fill="none" viewBox="0 0 11 13" {...props}>
    <path
      fill="#000C37"
      d="M.2 11.69c0 .634.514 1.148 1.147 1.148h8.414c.633 0 1.147-.514 1.147-1.148v-6.5H.2zm7.65-4.589c0-.21.17-.382.382-.382h.765c.211 0 .382.171.382.382v.765a.38.38 0 0 1-.382.383H8.23a.38.38 0 0 1-.382-.383zm0 3.06c0-.212.17-.383.382-.383h.765c.211 0 .382.171.382.383v.765a.38.38 0 0 1-.382.382H8.23a.38.38 0 0 1-.382-.383zM4.789 7.1c0-.21.171-.382.383-.382h.765c.21 0 .382.171.382.382v.765a.38.38 0 0 1-.382.383h-.765a.38.38 0 0 1-.383-.383zm0 3.06c0-.212.171-.383.383-.383h.765c.21 0 .382.171.382.383v.765a.38.38 0 0 1-.382.382h-.765a.38.38 0 0 1-.383-.383zM1.73 7.1c0-.21.172-.382.383-.382h.765c.211 0 .383.171.383.382v.765a.38.38 0 0 1-.383.383h-.765a.38.38 0 0 1-.382-.383zm0 3.06c0-.212.172-.383.383-.383h.765c.211 0 .383.171.383.383v.765a.38.38 0 0 1-.383.382h-.765a.38.38 0 0 1-.382-.383zm8.032-8.03H8.613v-.765A.767.767 0 0 0 7.85.6a.767.767 0 0 0-.765.765v.765h-3.06v-.765A.767.767 0 0 0 3.26.6a.767.767 0 0 0-.765.765v.765H1.347C.714 2.13.2 2.643.2 3.277v1.147h10.708V3.277c0-.634-.514-1.147-1.147-1.147"
    ></path>
  </svg>
));

export const MapIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <g>
      <path
        fill="#000c37"
        d="M8 1a5.25 5.25 0 0 0-5.25 5.25c0 2.116.738 2.707 4.712 8.468a.656.656 0 0 0 1.078 0c3.972-5.761 4.71-6.352 4.71-8.468A5.25 5.25 0 0 0 8 1m0 7.412a2.19 2.19 0 0 1-2.187-2.187A2.19 2.19 0 0 1 8 4.038a2.19 2.19 0 0 1 2.188 2.187A2.19 2.19 0 0 1 8 8.412"
      ></path>
    </g>
  </svg>
));

export const NotificationsIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <g>
      <path
        fill="#000C37"
        d="M3.2 11.92V10.8h1.2V6.88q0-1.162.75-2.058.75-.91 1.95-1.19V3.24q0-.35.255-.588A.91.91 0 0 1 8 2.4q.375 0 .63.252.27.238.27.588v.392q1.2.28 1.95 1.19.75.896.75 2.058v3.92h1.2v1.12zM8 13.6a1.24 1.24 0 0 1-.855-.322 1.08 1.08 0 0 1-.345-.798h2.4q0 .462-.36.798-.345.322-.84.322m-2.4-2.8h4.8V6.88q0-.924-.705-1.582A2.4 2.4 0 0 0 8 4.64q-.99 0-1.695.658T5.6 6.88z"
      ></path>
    </g>
  </svg>
));

export const ShipmentsIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <g>
      <path
        fill="#000c37"
        d="M4.242 11.3c.327.32.964.585 1.421.59.516 0 1.126-.143 1.437-.532.214-.274.547-.43.9-.434.351.003.684.16.9.431.311.39.92.533 1.437.533.457-.005 1.095-.27 1.421-.59l2.236-2.158a.9.9 0 0 0 .228-.55.83.83 0 0 0-.54-.74l-1.015-.327v-3.41a.78.78 0 0 0-.778-.779h-1.534l-.022-.973a.583.583 0 0 0-.583-.584h-3.5a.585.585 0 0 0-.584.584l-.022.972-1.533.001a.78.78 0 0 0-.778.779v3.41l-1.016.326a.83.83 0 0 0-.54.741c0 .178.102.425.228.551zm.647-6.409h6.222v2.13l-2.873-.924A.8.8 0 0 0 8 6.065a.7.7 0 0 0-.238.032l-2.873.926zm9.474 7.795c-1.18-.206-1.106-.682-1.692-.682-.608 0-.758.736-2.337.736-1.181 0-1.768-.51-1.784-.524a.79.79 0 0 0-.545-.213c-.601 0-.768.737-2.338.737-1.181 0-1.767-.51-1.784-.523a.817.817 0 0 0-1.09-.008c-.706.607-1.793.29-1.793 1.205 0 .373.31.743.77.743.238 0 .965-.17 1.563-.506.474.267 1.252.572 2.336.572s1.857-.304 2.331-.571c.475.267 1.253.57 2.336.57s1.859-.304 2.332-.571c.601.337 1.331.505 1.562.505.459 0 .77-.366.77-.743a.75.75 0 0 0-.637-.727"
      ></path>
    </g>
  </svg>
));

export const DotIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" fill="none" viewBox="0 0 4 4" {...props}>
    <circle cx="2" cy="2" r="2" fill="#08F"></circle>
  </svg>
));

export const PrevIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24" {...props}>
    <path stroke="#000C37" strokeLinecap="round" d="m10 16 4-4-4-4"></path>
  </svg>
));

export const FilterIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="#000C37"
      d="M14.883 2.605c-.21-.45-.654-.73-1.159-.73H2.276c-.505 0-.949.28-1.159.73-.204.439-.138.942.174 1.315l4.521 5.554v1.851c0 .344.17.665.452.86l2.251 1.738q.295.204.617.202c.582 0 1.055-.47 1.055-1.048V9.474l4.526-5.559c.308-.368.374-.871.17-1.31m-5.811 6.16a.88.88 0 0 0-.197.553v3.224l-1.75-1.35V9.318a.88.88 0 0 0-.197-.553L2.388 3.19h11.223z"
    ></path>
  </svg>
));

export const OrderIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="none" viewBox="0 0 12 12" {...props}>
    <path
      fill="#000C37"
      d="M5.625 2.25h1.5a.375.375 0 0 0 .375-.375v-.75A.375.375 0 0 0 7.125.75h-1.5a.375.375 0 0 0-.375.375v.75a.375.375 0 0 0 .375.375m0 3h3A.375.375 0 0 0 9 4.875v-.75a.375.375 0 0 0-.375-.375h-3a.375.375 0 0 0-.375.375v.75a.375.375 0 0 0 .375.375m6 4.5h-6a.375.375 0 0 0-.375.375v.75a.375.375 0 0 0 .375.375h6a.375.375 0 0 0 .375-.375v-.75a.375.375 0 0 0-.375-.375m-6-1.5h4.5a.375.375 0 0 0 .375-.375v-.75a.375.375 0 0 0-.375-.375h-4.5a.375.375 0 0 0-.375.375v.75a.375.375 0 0 0 .375.375m-5.25-4.5H1.5v7.125a.375.375 0 0 0 .375.375h.75A.375.375 0 0 0 3 10.875V3.75h1.125a.375.375 0 0 0 .265-.64L2.515.86a.375.375 0 0 0-.53 0L.11 3.11a.375.375 0 0 0 .265.64"
    ></path>
  </svg>
));

export const ArrowDown1Icon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none" viewBox="0 0 10 10" {...props}>
    <g clipPath="url(#clip0_2284_39324)">
      <path
        fill="#000C37"
        d="M6.065 1.434 9.19 4.559a.622.622 0 0 1 0 .883L6.067 8.567a.625.625 0 1 1-.884-.884l2.06-2.058H1.248a.606.606 0 0 1-.607-.607c0-.328.262-.643.607-.643h5.992L5.183 2.317a.625.625 0 1 1 .882-.883"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_2284_39324">
        <path fill="#fff" d="M-.001 10V0h10v10z"></path>
      </clipPath>
    </defs>
  </svg>
));

export const AcceptIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" fill="none" viewBox="0 0 60 60" {...props}>
    <circle cx="30" cy="30" r="30" fill="url(#paint0_linear_187_15997)"></circle>
    <path
      fill="#fff"
      d="M42.369 24.861 28.576 39.337c-.421.442-.973.663-1.524.663-.552 0-1.103-.22-1.524-.663L18.631 32.1a2.34 2.34 0 0 1 0-3.198 2.083 2.083 0 0 1 3.048 0l5.373 5.639 12.27-12.877a2.083 2.083 0 0 1 3.047 0 2.34 2.34 0 0 1 0 3.198"
    ></path>
    <defs>
      <linearGradient id="paint0_linear_187_15997" x1="30" x2="30" y1="0" y2="60" gradientUnits="userSpaceOnUse">
        <stop stopColor="#37D090"></stop>
        <stop offset="1" stopColor="#17A28E"></stop>
      </linearGradient>
    </defs>
  </svg>
));

export const ArrowRotateLeftIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="#000C37"
      d="M13.502 8.432A5.075 5.075 0 0 1 8.434 13.5a5.02 5.02 0 0 1-3.037-1.015.724.724 0 1 1 .87-1.159c.63.473 1.38.723 2.17.723a3.62 3.62 0 0 0 3.617-3.617 3.62 3.62 0 0 0-3.617-3.617c-1.139 0-2.21.546-2.888 1.444h1.435a.724.724 0 1 1 0 1.449h-3.26A.724.724 0 0 1 3 6.984v-3.26a.724.724 0 1 1 1.449 0v1.59a5.05 5.05 0 0 1 3.985-1.95 5.075 5.075 0 0 1 5.068 5.068"
    ></path>
  </svg>
));

export const CloseIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="#000C37"
      fillRule="evenodd"
      d="M5.218 14.117a.74.74 0 0 0 0 1.049c.29.29.761.29 1.052 0l3.936-3.926 3.938 3.927c.29.29.761.29 1.052 0a.74.74 0 0 0 0-1.049l-3.938-3.927 3.938-3.927a.74.74 0 0 0 0-1.049.745.745 0 0 0-1.052 0l-3.938 3.927L6.27 5.217a.745.745 0 0 0-1.052 0 .74.74 0 0 0 0 1.05l3.936 3.924z"
      clipRule="evenodd"
    ></path>
  </svg>
));

export const ErrorIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="69" height="61" fill="none" viewBox="0 0 69 61" {...props}>
    <path
      fill="url(#paint0_linear_187_15326)"
      d="M30.736 2.378c1.673-2.898 5.856-2.898 7.53 0L67.914 53.73c1.673 2.898-.419 6.52-3.765 6.52H4.853c-3.347 0-5.438-3.622-3.765-6.52z"
    ></path>
    <g filter="url(#filter0_ii_187_15326)">
      <path
        fill="#fff"
        d="M31.893 22.282a2.499 2.499 0 0 1 4.997 0v11.659a2.499 2.499 0 0 1-4.997 0zm2.499 24.15a3.331 3.331 0 1 1 0-6.662 3.331 3.331 0 0 1 0 6.662"
      ></path>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_187_15326"
        x1="10.1"
        x2="65.101"
        y1="37.733"
        y2="92.494"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3B57"></stop>
        <stop offset="1" stopColor="#892168"></stop>
      </linearGradient>
      <filter
        id="filter0_ii_187_15326"
        width="16.662"
        height="34.648"
        x="25.061"
        y="15.784"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape"></feBlend>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dx="-6" dy="-4"></feOffset>
        <feGaussianBlur stdDeviation="3"></feGaussianBlur>
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"></feComposite>
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"></feColorMatrix>
        <feBlend in2="shape" result="effect1_innerShadow_187_15326"></feBlend>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dx="4" dy="4"></feOffset>
        <feGaussianBlur stdDeviation="2.5"></feGaussianBlur>
        <feComposite in2="hardAlpha" k2="-1" k3="1" operator="arithmetic"></feComposite>
        <feColorMatrix values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"></feColorMatrix>
        <feBlend in2="effect1_innerShadow_187_15326" result="effect2_innerShadow_187_15326"></feBlend>
      </filter>
    </defs>
  </svg>
));

export const ExcelDownloadIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="65" height="55" fill="none" viewBox="0 0 65 55" {...props}>
    <g clipPath="url(#clip0_516_13146)">
      <path
        fill="#000C37"
        d="M41.19 13.912V.377H22.58a5.076 5.076 0 0 0-5.076 5.076v43.989a5.076 5.076 0 0 0 5.076 5.075h30.454a5.076 5.076 0 0 0 5.075-5.075V17.296H44.67c-1.966 0-3.479-1.512-3.479-3.384m5.087 14.423-5.087 8.418 5.18 8.418c.7 1.13-.114 2.579-1.436 2.579h-2.795a1.69 1.69 0 0 1-1.441-.806l-2.891-4.693-2.888 4.693c-.306.5-.856.806-1.437.806H30.68c-1.324 0-2.136-1.452-1.442-2.58l5.185-8.417-5.182-8.418c-.697-1.131.117-2.58 1.439-2.58h2.794c.588 0 1.133.305 1.442.805l2.89 4.694 2.888-4.694a1.7 1.7 0 0 1 1.438-.805h2.794c1.33 0 2.144 1.449 1.35 2.58M44.574.377v13.535H58.11z"
      ></path>
    </g>
    <path
      fill="#000C37"
      d="m.86 26.33 7.595-7.595a2.278 2.278 0 1 1 3.223 3.222l-3.792 3.709h10.453v4.557H7.886l3.705 3.706c.453.443.672 1.022.672 1.61a2.278 2.278 0 0 1-3.89 1.611L.777 29.557A2.22 2.22 0 0 1 .86 26.33"
    ></path>
    <defs>
      <clipPath id="clip0_516_13146">
        <path fill="#fff" d="M10.736.377h54.141v54.141h-54.14z"></path>
      </clipPath>
    </defs>
  </svg>
));

export const ExcelUploadIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="67" height="55" fill="none" viewBox="0 0 67 55" {...props}>
    <g clipPath="url(#clip0_516_13159)">
      <path
        fill="#000C37"
        d="M31.19 13.912V.377H12.58a5.076 5.076 0 0 0-5.076 5.076v43.989a5.076 5.076 0 0 0 5.076 5.075h30.454a5.076 5.076 0 0 0 5.075-5.075V17.296H34.67c-1.966 0-3.479-1.512-3.479-3.384m5.087 14.423-5.087 8.418 5.18 8.418c.7 1.13-.114 2.579-1.436 2.579h-2.795a1.69 1.69 0 0 1-1.441-.806l-2.891-4.693-2.888 4.693c-.306.5-.856.806-1.437.806H20.68c-1.324 0-2.136-1.452-1.442-2.58l5.185-8.417-5.182-8.418c-.697-1.131.117-2.58 1.439-2.58h2.794c.588 0 1.133.305 1.442.805l2.89 4.694 2.888-4.694a1.7 1.7 0 0 1 1.438-.805h2.794c1.33 0 2.144 1.449 1.35 2.58M34.574.377v13.535H48.11z"
      ></path>
    </g>
    <path
      fill="#000C37"
      d="m65.48 26.33-7.596-7.595a2.278 2.278 0 1 0-3.223 3.222l3.792 3.709H48v4.557h10.453l-3.705 3.706a2.23 2.23 0 0 0-.672 1.61 2.278 2.278 0 0 0 3.89 1.611l7.596-7.594a2.22 2.22 0 0 0-.083-3.226"
    ></path>
    <defs>
      <clipPath id="clip0_516_13159">
        <path fill="#fff" d="M.736.377h54.141v54.141H.737z"></path>
      </clipPath>
    </defs>
  </svg>
));

export const UploadIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="#000C37"
        d="M13.25 9.313h-3.5v1.312h3.5c.241 0 .438.196.438.438v2.187a.44.44 0 0 1-.438.438H2.75a.44.44 0 0 1-.437-.438v-2.187c0-.242.196-.438.437-.438h3.5V9.313h-3.5A1.75 1.75 0 0 0 1 11.063v2.187c0 .966.784 1.75 1.75 1.75h10.5A1.75 1.75 0 0 0 15 13.25v-2.187a1.75 1.75 0 0 0-1.75-1.75M4.745 5.839 7.344 3.24v7.385a.656.656 0 0 0 1.312 0V3.24l2.599 2.599a.654.654 0 0 0 .928 0 .656.656 0 0 0 0-.928L8.464 1.192a.656.656 0 0 0-.928 0L3.817 4.911a.656.656 0 1 0 .928.928m8.067 6.317a.656.656 0 1 0-1.312 0 .656.656 0 0 0 1.313 0"
      ></path>
    </svg>
  ),
  "16x16"
);

export const UpdateIcon = withDefaultStyles(
  (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="#000C37"
        d="M13.796 8.96a.7.7 0 0 0-.867.476 5.16 5.16 0 0 1-4.93 3.696c-1.94 0-3.696-1.117-4.562-2.8h2.929a.7.7 0 0 0 0-1.4H1.7a.7.7 0 0 0-.7.7v4.666a.7.7 0 0 0 1.4 0V11.32c1.159 1.94 3.27 3.212 5.6 3.212 2.886 0 5.466-1.934 6.272-4.704a.7.7 0 0 0-.476-.867M14.3 1a.7.7 0 0 0-.7.7v2.977c-1.159-1.94-3.27-3.21-5.6-3.21-2.886 0-5.466 1.933-6.272 4.703a.699.699 0 1 0 1.343.392 5.16 5.16 0 0 1 4.93-3.696c1.94 0 3.697 1.117 4.563 2.8h-2.93a.7.7 0 0 0 0 1.4H14.3a.7.7 0 0 0 .7-.7V1.7a.7.7 0 0 0-.7-.7"
      ></path>
    </svg>
  ),
  "16x16"
);

export const ArrowTopRightIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" fill="none" viewBox="0 0 21 20" {...props}>
    <path
      stroke="#08F"
      strokeLinecap="round"
      strokeWidth="2"
      d="M12.672 13.485V8.83a1 1 0 0 0-1-1H7.015M6.5 14l5-5"
    ></path>
  </svg>
));

export const FreePaymentsIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32" {...props}>
    <g id="badge-check">
      <path
        id="Vector"
        fill="url(#paint0_linear_522_25795)"
        d="M29.999 16a5.67 5.67 0 0 0-2.563-4.744 5.65 5.65 0 0 0-1.539-5.154 5.65 5.65 0 0 0-5.16-1.545C19.679 3.025 17.984 2 15.999 2s-3.735 1.025-4.796 2.557C9.453 4.18 7.506 4.7 6.1 6.102a5.65 5.65 0 0 0-1.548 5.157A5.67 5.67 0 0 0 2 16c0 1.98 1.02 3.732 2.55 4.744a5.66 5.66 0 0 0 1.55 5.154 5.62 5.62 0 0 0 5.148 1.545A5.69 5.69 0 0 0 15.999 30a5.67 5.67 0 0 0 4.738-2.557 5.66 5.66 0 0 0 5.16-1.545 5.64 5.64 0 0 0 1.54-5.154A5.67 5.67 0 0 0 29.998 16m-8.734-2.182-6.125 6.125c-.208.306-.547.432-.88.432-.334 0-.672-.128-.928-.384l-2.625-2.625a1.312 1.312 0 1 1 1.856-1.857l1.697 1.7 5.197-5.197a1.31 1.31 0 0 1 1.856 0c.513.512.51 1.341-.048 1.806"
      ></path>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_522_25795"
        x1="2.001"
        x2="35.077"
        y1="30"
        y2="10.706"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFAB1D"></stop>
        <stop offset="1" stopColor="#F8501C"></stop>
      </linearGradient>
    </defs>
  </svg>
));

export const PaidPaymentsIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="none" viewBox="0 0 28 28" {...props}>
    <path
      fill="url(#paint0_linear_646_10966)"
      d="M27.999 14a5.67 5.67 0 0 0-2.563-4.744 5.65 5.65 0 0 0-1.539-5.154 5.65 5.65 0 0 0-5.16-1.545C17.679 1.025 15.984 0 13.999 0s-3.735 1.025-4.796 2.557C7.453 2.18 5.506 2.7 4.1 4.102a5.65 5.65 0 0 0-1.548 5.157A5.67 5.67 0 0 0 0 14c0 1.98 1.02 3.732 2.55 4.744a5.66 5.66 0 0 0 1.55 5.154 5.62 5.62 0 0 0 5.148 1.545A5.69 5.69 0 0 0 13.999 28a5.67 5.67 0 0 0 4.738-2.557 5.66 5.66 0 0 0 5.16-1.545 5.64 5.64 0 0 0 1.54-5.154A5.67 5.67 0 0 0 27.998 14m-8.734-2.182-6.125 6.125c-.208.306-.547.432-.88.432-.334 0-.672-.128-.928-.384l-2.625-2.625a1.312 1.312 0 1 1 1.856-1.857l1.697 1.7 5.197-5.197a1.31 1.31 0 0 1 1.856 0c.513.512.51 1.341-.048 1.806"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_646_10966"
        x1="0.001"
        x2="33.077"
        y1="28"
        y2="8.706"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#13C549"></stop>
        <stop offset="1" stopColor="#0DBBBB"></stop>
      </linearGradient>
    </defs>
  </svg>
));

export const CrossIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="none" viewBox="0 0 14 14" {...props}>
    <g stroke="currentColor" strokeLinecap="round" strokeWidth="1.5" clipPath="url(#clip0)">
      <path d="m4.5 5.168 5 5M9.5 5.168l-5 5"></path>
    </g>
    <defs>
      <clipPath id="clip0">
        <path fill="#fff" d="M0 .668h14v14H0z"></path>
      </clipPath>
    </defs>
  </svg>
));

export const TrainIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="#000C37"
      d="M11.5 1h-7a2.625 2.625 0 0 0-2.625 2.625v7a2.616 2.616 0 0 0 2.344 2.597l-1.405 1.405A.219.219 0 0 0 2.97 15h1.147a.44.44 0 0 0 .31-.128l1.622-1.622h3.904l1.622 1.622a.44.44 0 0 0 .312.128h1.146a.219.219 0 0 0 .155-.373l-1.405-1.405a2.615 2.615 0 0 0 2.343-2.597v-7A2.625 2.625 0 0 0 11.5 1M8 11.063c-.723 0-1.312-.59-1.312-1.313S7.278 8.438 8 8.438s1.313.589 1.313 1.312S8.722 11.063 8 11.063m4.375-4.813a.88.88 0 0 1-.875.875h-7a.88.88 0 0 1-.875-.875V3.625c0-.481.394-.875.875-.875h7c.481 0 .875.394.875.875z"
    ></path>
  </svg>
));

export const AllSeaCarriersIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <rect width="20" height="20" fill="url(#paint0_linear_3854_2634)" rx="3.333"></rect>
    <g clipPath="url(#clip0_3854_2634)">
      <path
        fill="#fff"
        d="M7.26 12.372c.238.233.703.426 1.036.43.376 0 .821-.104 1.048-.389a.84.84 0 0 1 .656-.316.85.85 0 0 1 .656.315c.227.284.672.388 1.048.388.333-.004.798-.196 1.036-.43l1.63-1.574a.65.65 0 0 0 .167-.4.6.6 0 0 0-.394-.541l-.74-.237V7.13a.57.57 0 0 0-.568-.568h-1.118l-.016-.71a.425.425 0 0 0-.425-.425H8.724a.426.426 0 0 0-.426.425l-.016.71H7.164a.57.57 0 0 0-.567.568v2.486l-.74.238a.6.6 0 0 0-.394.54c0 .13.074.31.166.402zm.471-4.674h4.537v1.553l-2.095-.674A.6.6 0 0 0 10 8.554a.5.5 0 0 0-.174.023l-2.095.675zm6.909 5.684c-.86-.15-.807-.498-1.234-.498-.443 0-.553.537-1.705.537-.86 0-1.288-.372-1.3-.382a.57.57 0 0 0-.397-.155c-.439 0-.56.537-1.705.537-.862 0-1.289-.372-1.301-.381a.595.595 0 0 0-.795-.006c-.514.443-1.307.211-1.307.879 0 .271.226.541.562.541.173 0 .702-.124 1.139-.368.345.194.913.416 1.703.416s1.354-.221 1.7-.416c.346.195.914.416 1.703.416.79 0 1.355-.222 1.701-.416.438.245.97.368 1.139.368a.55.55 0 0 0 .561-.542.55.55 0 0 0-.464-.53"
      ></path>
    </g>
    <defs>
      <linearGradient id="paint0_linear_3854_2634" x1="0" x2="23.627" y1="20" y2="6.217" gradientUnits="userSpaceOnUse">
        <stop stopColor="#50ADFF"></stop>
        <stop offset="1" stopColor="#006FF1"></stop>
      </linearGradient>
      <clipPath id="clip0_3854_2634">
        <path fill="#fff" d="M4.167 4.13h11.667v11.668H4.167z"></path>
      </clipPath>
    </defs>
  </svg>
));

export const AllAirCarriersIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <g clipPath="url(#all-air-carriers-clip)">
      <path
        fill="url(#all-air-carriers-gradient)"
        d="M16.667 0H3.333A3.333 3.333 0 0 0 0 3.333v13.334A3.333 3.333 0 0 0 3.333 20h13.334A3.333 3.333 0 0 0 20 16.667V3.333A3.333 3.333 0 0 0 16.667 0"
      ></path>
      <mask
        id="all-air-carriers-mask"
        width="12"
        height="12"
        x="4"
        y="4"
        maskUnits="userSpaceOnUse"
        style={{ maskType: "luminance" }}
      >
        <path fill="#fff" d="M4.167 4.13h11.667v11.668H4.167z"></path>
      </mask>
      <g mask="url(#all-air-carriers-mask)">
        <path
          fill="#fff"
          d="m12.889 10.332.195.837q.021-.012.036-.023l.13-.104a.29.29 0 0 1 .327-.029c.179.096.285.25.33.447a.23.23 0 0 1-.026.155c-.033.067-.093.108-.147.153q-.204.17-.41.339l-.013.014q.002.02.005.04l.243 1.132q.086.399.17.797c.02.1-.003.19-.075.262q-.12.122-.248.238a1 1 0 0 1-.108.078c-.104.065-.217.036-.275-.071a187 187 0 0 1-.896-1.687l-.749-1.43-.558-1.065q-.046-.09-.12-.022-.101.095-.202.192l-.343.317-.24.222-.36.324q-.107.1-.218.198l-.28.25-.201.178q-.164.147-.33.29c-.05.042-.068.08-.053.148q.09.416.172.835l.154.763q.031.155.065.31a.27.27 0 0 1-.066.248q-.15.17-.34.296c-.104.068-.22.037-.277-.069l-.468-.87-.418-.774-.02-.03q-.085.041-.17.08c-.111.053-.222.107-.344.135a.3.3 0 0 1-.063.008c-.065-.003-.11-.05-.107-.116a.3.3 0 0 1 .02-.093q.09-.218.183-.436l.025-.056q-.01-.01-.02-.016l-1.159-.61-.532-.28a.2.2 0 0 1-.097-.102.17.17 0 0 1 .028-.167c.098-.128.2-.253.319-.362a.24.24 0 0 1 .215-.056l.47.09 1.256.23.174.03q.022.004.048.006l.162-.202.412-.515q.253-.312.51-.623.341-.413.684-.826.084-.098.166-.197c.039-.046.03-.09-.022-.118q-.568-.305-1.136-.607a70 70 0 0 0-.861-.449q-.844-.431-1.689-.859-.217-.112-.437-.219c-.124-.06-.135-.194-.065-.289.094-.127.204-.24.317-.349a.24.24 0 0 1 .225-.057l1.17.243.64.137.057.01.13-.161c.076-.095.15-.192.231-.282.07-.076.16-.1.26-.072a.66.66 0 0 1 .403.3c.08.136.079.254-.024.383l-.038.048.804.166.15-.184q.106-.13.215-.255a.25.25 0 0 1 .272-.077.66.66 0 0 1 .38.273c.09.137.091.29-.022.415l-.023.03c.038.018.74.158.813.161l.053-.055.88-.92.652-.67c.098-.099.194-.201.3-.292.22-.189.471-.323.76-.375a.95.95 0 0 1 .42.01q.248.066.347.301.044.102.053.212c.002.029.009.057.009.085.003.188-.034.37-.102.544a2.2 2.2 0 0 1-.252.46c-.074.106-.162.2-.25.293q-.223.237-.448.47l-.755.788-.386.399.177.79.109-.086a.28.28 0 0 1 .296-.049c.096.038.17.1.231.184.054.074.096.15.124.237a.27.27 0 0 1-.088.29l-.437.372q-.003.003-.01.012"
        ></path>
      </g>
    </g>
    <defs>
      <linearGradient
        id="all-air-carriers-gradient"
        x1="0"
        x2="23.627"
        y1="20"
        y2="6.217"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#EE8989"></stop>
        <stop offset="1" stopColor="#F81B1B"></stop>
      </linearGradient>
      <clipPath id="all-air-carriers-clip">
        <path fill="#fff" d="M0 0h20v20H0z"></path>
      </clipPath>
    </defs>
  </svg>
));

export const AllParcelCarriersIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="url(#paint0_linear_5412_10550)"
      d="M0 6.4c0-2.24 0-3.36.436-4.216A4 4 0 0 1 2.184.436C3.04 0 4.16 0 6.4 0h7.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C20 3.04 20 4.16 20 6.4v7.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C16.96 20 15.84 20 13.6 20H6.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C0 16.96 0 15.84 0 13.6z"
    ></path>
    <path
      fill="#fff"
      d="m13.993 8.264-1.007-1.873A.57.57 0 0 0 12.445 6h-2.16v2.286h3.694c.005-.01.009-.013.014-.022M6 8.857v4.286c0 .473.384.857.857.857h6.286a.857.857 0 0 0 .857-.857V8.857zm3.714-.571V6H7.556a.57.57 0 0 0-.543.39L6.007 8.265l.015.022z"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_5412_10550"
        x1="0"
        x2="20.004"
        y1="1.419"
        y2="20.004"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFD194"></stop>
        <stop offset="1" stopColor="#D1913C"></stop>
      </linearGradient>
    </defs>
  </svg>
));

export const ShipmentTypeRoadIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" fill="none" viewBox="0 0 16 12" {...props}>
    <path
      fill="currentColor"
      d="m15.532 5.498-1.463-1.567a1.54 1.54 0 0 0-1.124-.5H12V1.715C12 .767 11.284 0 10.4 0H1.6C.716 0 0 .767 0 1.714V9.74c0 1.093.715 2.094 1.726 2.24.768.111 1.458-.253 1.874-.847.42.603 1.118.963 1.893.845.811-.125 1.477-.822 1.66-1.677.068-.324.055-.598.006-.872h4.082a2 2 0 0 0-.033.235c-.09 1.084.638 2.121 1.638 2.304 1.263.23 2.354-.801 2.354-2.11q-.002-.22-.04-.43h.44c.219 0 .4-.194.4-.428V6.71c0-.455-.168-.89-.468-1.212M2 10.714c-.44 0-.8-.385-.8-.857S1.56 9 2 9s.8.385.8.857-.36.857-.8.857m3.2 0c-.44 0-.8-.385-.8-.857S4.76 9 5.2 9s.8.385.8.857-.36.857-.8.857m8 0c-.44 0-.8-.385-.8-.857S12.76 9 13.2 9s.8.385.8.857-.36.857-.8.857M12 6V4.714h.938c.106 0 .206.047.28.128L14.304 6z"
    ></path>
  </svg>
));

export const ParcelTrackingIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
    <g filter="url(#filter0_d_5378_10671)">
      <g clipPath="url(#clip0_5378_10671)">
        <path
          fill="url(#paint0_linear_5378_10671)"
          d="M0 13.333c0-4.667 0-7 .908-8.783A8.33 8.33 0 0 1 4.55.908C6.333 0 8.666 0 13.333 0h13.334c4.667 0 7 0 8.783.908a8.33 8.33 0 0 1 3.642 3.642C40 6.333 40 8.666 40 13.333v13.334c0 4.667 0 7-.908 8.783a8.33 8.33 0 0 1-3.642 3.642C33.667 40 31.334 40 26.667 40H13.333c-4.667 0-7 0-8.783-.908A8.33 8.33 0 0 1 .908 35.45C0 33.667 0 31.334 0 26.667z"
        ></path>
        <path
          fill="url(#paint1_linear_5378_10671)"
          d="M15.635 27.766a.24.24 0 0 1 .005-.343l8.564-8.383a.26.26 0 0 1 .362.002l4.307 4.338a.24.24 0 0 1 .001.341l-8.468 8.593a.26.26 0 0 1-.367-.002z"
        ></path>
        <path
          fill="url(#paint2_linear_5378_10671)"
          d="M13.522 25.59a.255.255 0 0 1-.366.003c-.324-.333-1.006-1.045-1.43-1.576-.464-.58-.989-1.554-1.17-1.899a.24.24 0 0 1 .015-.244l2.887-4.267a.26.26 0 0 1 .37-.058l4.041 3.138c.116.09.128.256.027.36z"
        ></path>
        <path
          fill="url(#paint3_linear_5378_10671)"
          d="M12.708 25.125c-2.103-2.045-3.105-4.675-3.105-7.304s1.002-5.259 3.105-7.304 4.806-3.019 7.51-3.019 5.408.974 7.51 3.019c2.104 2.045 3.105 4.674 3.105 7.304s-1.001 5.259-3.104 7.304l-7.331 7.197a.25.25 0 0 1-.355-.004l-1.707-1.759a.25.25 0 0 1 .005-.353c2.441-2.377 4.84-4.75 7.285-7.126 1.502-1.461 2.203-3.311 2.203-5.26 0-1.85-.701-3.797-2.203-5.258s-3.405-2.142-5.408-2.142c-1.903 0-3.905.681-5.408 2.142-1.502 1.46-2.203 3.311-2.203 5.259 0 1.85.701 3.798 2.204 5.259l.419.364a.25.25 0 0 1 .016.362l-1.716 1.79a.25.25 0 0 1-.359.002z"
        ></path>
        <path
          fill="url(#paint4_linear_5378_10671)"
          d="M15.511 22.398c-1.302-1.266-1.902-2.921-1.902-4.577 0-1.655.6-3.31 1.902-4.577s3.005-1.85 4.707-1.85 3.405.584 4.706 1.85 1.903 2.922 1.903 4.577c0 1.656-.401 3.311-1.703 4.577l-7.478 7.115a.25.25 0 0 1-.353-.009l-1.652-1.737a.25.25 0 0 1 .005-.35l4.572-4.532 1.302-1.266 1.302-1.266c.7-.681 1.101-1.655 1.101-2.532 0-.876-.4-1.85-1.101-2.532s-1.703-1.071-2.604-1.071-1.903.39-2.604 1.071c-.7.682-1.101 1.656-1.101 2.532s.4 1.85 1.101 2.532l.313.304a.25.25 0 0 1 .004.354l-1.695 1.732a.25.25 0 0 1-.35.008z"
        ></path>
      </g>
    </g>
    <defs>
      <linearGradient id="paint0_linear_5378_10671" x1="-5" x2="35.833" y1="0" y2="40" gradientUnits="userSpaceOnUse">
        <stop stopColor="#FACB8C"></stop>
        <stop offset="1" stopColor="#D59644"></stop>
      </linearGradient>
      <linearGradient
        id="paint1_linear_5378_10671"
        x1="17.387"
        x2="27.543"
        y1="29.921"
        y2="22.549"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.7"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="paint2_linear_5378_10671"
        x1="15.751"
        x2="14.815"
        y1="24.387"
        y2="20.433"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" stopOpacity="0.7"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="paint3_linear_5378_10671"
        x1="20.218"
        x2="12.31"
        y1="32.498"
        y2="-1.108"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff"></stop>
        <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <linearGradient
        id="paint4_linear_5378_10671"
        x1="13.609"
        x2="15.184"
        y1="39.847"
        y2="-24.484"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff"></stop>
        <stop offset="0.847" stopColor="#fff" stopOpacity="0"></stop>
      </linearGradient>
      <clipPath id="clip0_5378_10671">
        <rect width="40" height="40" fill="#fff" rx="8.333"></rect>
      </clipPath>
      <filter
        id="filter0_d_5378_10671"
        width="65"
        height="65"
        x="-12.5"
        y="-10"
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        ></feColorMatrix>
        <feOffset dy="2.5"></feOffset>
        <feGaussianBlur stdDeviation="6.25"></feGaussianBlur>
        <feColorMatrix values="0 0 0 0 0.0509804 0 0 0 0 0.741176 0 0 0 0 0.717647 0 0 0 0.2 0"></feColorMatrix>
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_5378_10671"></feBlend>
        <feBlend in="SourceGraphic" in2="effect1_dropShadow_5378_10671" result="shape"></feBlend>
      </filter>
    </defs>
  </svg>
));

const currentPinArrowPath =
  "M7.25191 3.83214L7.74744 3.34273C7.79634 3.29361 7.85506 3.25453 7.92006 3.22783C7.98506 3.20114 8.05501 3.18737 8.12568 3.18737C8.19635 3.18737 8.26629 3.20114 8.3313 3.22783C8.3963 3.25453 8.45502 3.29361 8.50391 3.34273L12.8428 7.62542C12.9435 7.7256 12.9999 7.85959 12.9999 7.99903C12.9999 8.13848 12.9435 8.27246 12.8428 8.37265L8.50391 12.6573C8.45502 12.7064 8.3963 12.7455 8.3313 12.7722C8.26629 12.7989 8.19635 12.8126 8.12568 12.8126C8.05501 12.8126 7.98506 12.7989 7.92006 12.7722C7.85506 12.7455 7.79634 12.7064 7.74744 12.6573L7.25191 12.1681C7.15011 12.0661 7.094 11.9298 7.09567 11.7884C7.09734 11.647 7.15666 11.5119 7.26083 11.4123L9.95034 8.88097H3.53584C3.23896 8.88097 3.00012 8.64464 3.00012 8.35181V7.64669C3.00012 7.35343 3.23896 7.11753 3.53584 7.11753H9.95034L7.26083 4.58817C7.15564 4.48902 7.09562 4.35375 7.09394 4.21204C7.09227 4.07034 7.14908 3.93357 7.25191 3.83214Z";

export type CurrentPinIconProps = SVGProps<SVGSVGElement> & {
  /** Rotation of the arrow in degrees; 0 — arrow up. */
  rotation?: number;
};

export const CurrentPinIcon = ({ rotation = 0, ...props }: CurrentPinIconProps) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="none" viewBox="0 0 40 40" {...props}>
      <circle cx="20" cy="20" r="20" fill="#0088FF" fillOpacity="0.2" />
      <circle cx="20" cy="20" r="10" fill="#0088FF" stroke="#fff" strokeWidth="2" />
      <g transform={`rotate(${rotation}, 20, 20)`}>
        <path transform="translate(12, 12)" fill="#fff" d={currentPinArrowPath} />
      </g>
    </svg>
  );
};

export const SunIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" aria-hidden {...props}>
    <circle cx="8" cy="8" r="3.25" stroke="currentColor" strokeWidth="1.5" />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="1.5"
      d="M8 1.5v1.25M8 13.25V14.5M1.5 8h1.25M13.25 8H14.5M3.4 3.4l.88.88M11.72 11.72l.88.88M3.4 12.6l.88-.88M11.72 4.28l.88-.88"
    />
  </svg>
));

export const MoonIcon = withDefaultStyles((props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none" viewBox="0 0 16 16" aria-hidden {...props}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
      d="M13.5 9.15A5.5 5.5 0 0 1 6.85 2.5 5.5 5.5 0 1 0 13.5 9.15Z"
    />
  </svg>
));
